import { render, staticRenderFns } from "./NMultiSelect.vue?vue&type=template&id=0134d596&"
import script from "./NMultiSelect.vue?vue&type=script&lang=js&"
export * from "./NMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./NMultiSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports